import { FilterTransformer } from './types';

export const serializeGroupDescription = ((id, value) => {
  const { userFollowedDataObjectGroups, groupDescription } = (value || {}) as {
    userFollowedDataObjectGroups?: boolean;
    groupDescription?: number;
  };
  return {
    name: groupDescription,
    userFollowedDataObjectGroups,
  };
}) satisfies FilterTransformer;

export const deserializeGroupDescription = ((id, value, allQueryFilters) => {
  const { userFollowedDataObjectGroups, name } = allQueryFilters as {
    userFollowedDataObjectGroups?: boolean;
    name?: number;
  };
  return {
    name:
      userFollowedDataObjectGroups || name
        ? {
            userFollowedDataObjectGroups,
            groupDescription: name,
          }
        : undefined,
  };
}) satisfies FilterTransformer;
